import { render, staticRenderFns } from "./custom-image-upload.vue?vue&type=template&id=0aabad85&scoped=true"
import script from "./custom-image-upload.vue?vue&type=script&lang=js"
export * from "./custom-image-upload.vue?vue&type=script&lang=js"
import style0 from "./custom-image-upload.vue?vue&type=style&index=0&id=0aabad85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aabad85",
  null
  
)

export default component.exports